<template>
  <b-card-code title="Nouvelle Certificat">
    <b-card-text>
      <span>Veuillez saisir les coordonnées de Certificat </span>
    </b-card-text>

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Label"
              label-for="Label"
            >
              <validation-provider
                #default="{ errors }"
                name="Label"
                rules="required"
              >
                <b-form-input
                  v-model="label"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Label"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Code"
              label-for="Code"
            >
              <validation-provider
                #default="{ errors }"
                name="Code"
                rules="required"
              >
                <b-form-input
                  v-model="code"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Code"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Frais d'inscription"
              label-for="Frais d'inscription"
            >
              <validation-provider
                #default="{ errors }"
                name="Frais d'inscription"
                rules="required"
              >
                <b-form-input
                  v-model="registration_fees"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Frais d'inscription"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Frais d'examen"
              label-for="Frais d'examen"
            >
              <validation-provider
                #default="{ errors }"
                name="Frais d'examen"
                rules="required"
              >
                <b-form-input
                  v-model="exam_fees"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Frais d'examen"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Niveau"
              label-for="Niveau"
            >
              <validation-provider
                #default="{ errors }"
                name="Niveau"
                rules="required"
              >
                <b-form-input
                  v-model="level"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Niveau"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-form-group
            label="Active"
            label-cols="10"
          >
            <b-form-checkbox
              v-model="isActive"
              class="mr-0 mt-50"
              name="is-active"
              switch
              inline
            />
          </b-form-group>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="addEmployee"
            >
              Ajouter
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
            >
              Réinitialiser
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
// import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText /*  */,
  BFormCheckbox,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,

    // vSelect,
  },
  data() {
    return {
      code: '',
      registration_fees: '',
      exam_fees: '',
      is_active: '',
      level: '',
      label: '',
      isActive: '',
      required,
    }
  },

  created() {
  },
  methods: {

    async addEmployee() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            await axios
              .post(
                '/api/certificates/create/',
                {
                  label: this.label,
                  code: this.code,
                  registration_fees: this.registration_fees,
                  exam_fees: this.exam_fees,
                  is_active: this.isActive,
                  level: this.level,
                },
              )
            this.$router.push('/Cetrificats')
            setTimeout(() => {
              this.showToast('success', 'top-center', 'Cetrificat ajouté avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
    formatPhone(e) {
      return String(e).substring(0, 8)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
